module.exports = __webpack_public_path__ + "images/967fb724ac99b081c551de5a29540772.png";